import log from 'salvo-lite/log'
import cssClasses from '../helpers/cssClasses'
import {on} from '../helpers/utils'

class Addresses {
    constructor (components) {
        this._name = this.constructor.name
        this._components = components

        /**
         * Node selectors.
         */
        this._nodeSelectors = {
            newAddressForm: document.querySelector('[js-addresses="newForm"]'),
            addressNewToggle: document.querySelectorAll('[js-addresses="newFormToggle"]'),
            addressEditToggle: document.querySelectorAll('[js-addresses="editAddress"]'),
            addressDeleteToggle: document.querySelectorAll('[js-addresses="deleteAddress"]'),
            countryOptions: document.querySelectorAll('[js-addresses="countryOption"]')
        }

        this._Shopify = window.Shopify
    }

    onInit () {
        log.debug(this._name, 'Initializing', this)
        this._addEvents()
        log.debug(this._name, 'Initiated', this)
    }

    _addEvents () {
        log.debug(this._name, 'Adding Events')
        this._setToggleEvents()
    }

    _setToggleEvents () {
        this._nodeSelectors.addressNewToggle.forEach((element) => {
            on('click', element, (event) => this._handleFormToggle(event))
        })

        this._nodeSelectors.addressEditToggle.forEach((element) => {
            on('click', element, (event) => this._handleEditToggle(event))
        })

        this._nodeSelectors.addressDeleteToggle.forEach((element) => {
            on('click', element, (event) => this._handleDelete(event))
        })

        if (this._nodeSelectors.newAddressForm) {
            if (this._Shopify) {
                this._initializeObservers()
            }

            this._initialiseEditObservers()
        }
    }

    /**
     * Initialize each edit form's country/province selector.
     */
    _initialiseEditObservers () {
        if (this._Shopify.country !== 'IT') {
            this._nodeSelectors.countryOptions.forEach((element) => {
                const formId = element.dataset.formId
                const countrySelector = `AddressCountry_${formId}`
                const provinceSelector = `AddressProvince_${formId}`
                const containerSelector = `AddressProvinceContainer_${formId}`

                this._Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
                    hideElement: containerSelector
                })
            })
        }
    }

    /**
     * Toggle address form.
     */
    _handleFormToggle (event) {
        event.preventDefault()
        this._nodeSelectors.newAddressForm.classList.toggle(cssClasses.hidden)
    }

    /**
     * Handle edit address toggle on each for element.
     * @param {Event} event - Click event.
     */
    _handleEditToggle (event) {
        const target = event.currentTarget
        const formId = target.dataset.formId
        document.querySelector(`#EditAddress_${formId}`).classList.toggle(cssClasses.hidden)
        document.querySelector(`#EditAddressContainer_${formId}`).classList.toggle(cssClasses.active)
    }

    /**
     * Handle delete on address.
     */
    _handleDelete (event) {
        const target = event.currentTarget
        const formId = target.dataset.formId
        const confirmMessage = target.dataset.confirmMessage

        if (
            window.confirm(
                confirmMessage || 'Are you sure you wish to delete this address?'
            )
        ) {
            this._Shopify.postLink(`/account/addresses/${formId}`, {
                parameters: {_method: 'delete'}
            })
        }
    }

    /**
     * Initialize observers on address selectors, defined in shopify_common.js.
     */
    _initializeObservers () {
        if (this._Shopify.country !== 'IT') {
            this._Shopify.CountryProvinceSelector(
                'AddressCountryNew',
                'AddressProvinceNew',
                {
                    hideElement: 'AddressProvinceContainerNew'
                }
            )
        }
    }
}

export default Addresses



// WEBPACK FOOTER //
// ./src/resources/scripts/pages/Addresses.js